<template>
    <div class="section-segment" ref="section" :id="sectionReference">
        <component
            v-for="segment in segmentData.segments"
            :key="segment.id"
            :is="segment.type + '-segment'"
            :segment-data="segment.data"
            :id="segment.id"
        ></component>
    </div>
</template>

<script>
import TextSegment from "~/components/handbook/segments/Text";
import TitleSegment from "~/components/handbook/segments/Title";
import ImageSegment from "~/components/handbook/segments/Image";
import PoiSegment from "~/components/handbook/segments/Poi";
import VideoSegment from "~/components/handbook/segments/Video";
import EmbeddedMediaSegment from "~/components/handbook/segments/EmbeddedMedia";
import QuoteSegment from "~/components/handbook/segments/Quote";
import DividerSegment from "~/components/handbook/segments/Divider";
import ColumnsSegment from "~/components/handbook/segments/Columns";
import EmbedSegment from "~/components/handbook/segments/Embed";
import { slugify } from "@/utils";

export default {
    components: {
        TextSegment,
        TitleSegment,
        ImageSegment,
        DividerSegment,
        PoiSegment,
        VideoSegment,
        QuoteSegment,
        ColumnsSegment,
        EmbeddedMediaSegment,
        EmbedSegment,
    },

    props: {
        id: String,
        segmentData: Object,
    },

    computed: {
        sectionReference() {
            if (this.segmentData.title) {
                return slugify(this.segmentData.title) + "-" + this.id;
            }

            return this.id;
        },
    },
};
</script>
